export default {
    members(state) {
        console.log('getter for members', state.members)
        return state.members
    },

    singleMember(state, id) {
        return state.members.find(member => member.id === id);
    },


    shouldUpdate(state) {
        const lastFetch = state.lastFetch;
        if (!lastFetch) {
            return true
        }
        const currentTimeStamp = new Date().getTime();
        return (currentTimeStamp - lastFetch) / 1000 > 60;
    },


}